<template>
  <GenericWrapperChart :config="config" />
</template>

<script>
import { numberFormatToPtBr, generateFileName } from '@/utils';

import { GenericWrapperChart } from '@/components/content/GenericWrapperChart';

export default {
  name: 'AverageInteractionsByPublication',
  components: {
    GenericWrapperChart,
  },
  data() {
    return {
      title: 'Média de interação por publicação',
    };
  },
  computed: {
    description() {
      if (this.$store.state.ui.channel === 'Todas') {
        return 'Soma das interações dividido pelo número de publicações por rede social no período selecionado.';
      }

      return 'Soma das interações dividido pelo número de publicações no período selecionado.';
    },
    overrideChartOptions() {
      const averageList = this.$store.state.charts.averageInteractionsByPublication.data.metadata;
      const filename = generateFileName(this.title);

      return {
        yAxis: {
          min: 0,
          title: {
            text: '',
          },
          stackLabels: {
            enabled: true,
            formatter() {
              const groupIndex = this.x;
              const groupName = this.axis.chart.options.xAxis[0].categories[groupIndex];
              const { total } = averageList.find(item => item.category === groupName);

              return `<b>${numberFormatToPtBr(total)}</b>`;
            },
          },
          labels: {
            enabled: false,
          },
          gridLineColor: '',
        },
        exporting: {
          enabled: false,
          sourceWidth: 750,
          filename,
          chartOptions: {
            title: {
              text: this.title,
            },
          },
        },
      };
    },
    config() {
      const isLoading = this.$store.state.charts.averageInteractionsByPublication.isLoading;
      const title = !isLoading ? this.title : '';
      const description = !isLoading ? this.description : '';
      const series = this.$store.state.charts.averageInteractionsByPublication.data.series;

      return {
        componentName: 'AverageInteractionsByPublication',
        title,
        description,
        isLoading,
        hasError: this.$store.state.charts.averageInteractionsByPublication.hasError,
        isEmpty: false,
        onError: this.getChartData,
        requestOnMounted: this.getChartData,
        downloadMenu: {
          trackNameOnOpen: 'BM ExportInteractionAveragePost Graph Open',
          trackNameOnDownload: 'BM ExportInteractionAveragePost Graph Click',
        },
        chart: {
          type: 'BasicBar',
          series,
          categories: this.$store.state.charts.averageInteractionsByPublication.data.categories,
          overrideChartOptions: this.overrideChartOptions,
          trackNameOnObserve: 'BM InteractionAveragePost Graph View',
          trackNameOnLegendClick: 'BM InteractionAveragePost LegendGraph Click',
        },
      };
    },
  },
  methods: {
    async getChartData() {
      await this.$store.dispatch('charts/fetchAverageInteractionsByPublication');
    },
  },
};
</script>
